import React, { useContext, useEffect } from "react";
import Routes from "./routes";
import AppContext from "./utils/Auth";
import TagManager from 'react-gtm-module';

const App: React.FC = () => {
  const { loading } = useContext(AppContext);
  // const gtmId = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "";
  // useEffect(() => {
  //   TagManager.initialize({ gtmId: gtmId });
  // }, []);
    

  if (loading) {
    return (
      <></>
    );
  }

  return (
    <div>
      <Routes />
    </div>
  );
};

export default App;
